

<template>
  <div class="invoiceManagement">
    <div class="main">
      <div class="top-search">
        <div class="item">
          <span>发票申请编号：</span>
          <div>
            <el-input v-model="applyNo" placeholder="单行输入"></el-input>
          </div>
        </div>
        <div class="item">
          <span>发票申请时间：</span>
          <div>
            <el-date-picker
              v-model="invoiceTime"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </div>
        <div class="item">
          <span>发票类型：</span>
          <div>
            <el-select v-model="type" placeholder="请选择">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span>发票状态：</span>
          <div>
            <el-select v-model="status" placeholder="请选择">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span style="width: 30px;"></span>
          <el-button type="primary" @click="delivererInvoicesPost()" size="small">搜索</el-button>
          <el-button type="danger" @click="reset" size="small">重置</el-button>
        </div>
      </div>
      <div class="bottom-table">
        <el-table :data="tableData" border :header-cell-style="{background:'rgb(250, 250, 250)'}" style="width: 100%">
          <el-table-column prop="apply_no" label="发票申请编号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="type" label="发票类型" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="invoice_amount" label="价税合计总额(元)" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="invoice_time" label="发票申请时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="statusName" label="发票状态" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="merchant_name" label="发票抬头" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="businessmen_name" label="开票方" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="address" label="操作" width="100">
            <template slot-scope="scope">
              <div style="cursor: pointer;">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" style="text-align: center;">
                    <el-dropdown-item>
                      <el-button
                        @click="handleClick(scope.row)"
                        type="primary"
                        size="mini"
                        plain
                      >查看详情</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="scope.row.status == '1030' || scope.row.status == '1070'"
                    >
                      <el-button
                        @click="newProgress(scope.row)"
                        type="danger"
                        size="mini"
                        plain
                      >新建进度</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.status == '1050'">
                      <el-button
                        @click="auditSubmit(scope.row)"
                        type="danger"
                        size="mini"
                        plain
                      >提交审核</el-button>
                    </el-dropdown-item>
                    <!-- <el-dropdown-item v-if="scope.row.status == '1050'"><el-button @click="auditSubmit(scope.row)" type="danger" size="mini" plain>拒绝</el-button></el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
      <!-- 查看详情 -->
      <el-dialog :visible.sync="dialogInvoice" width="1080px" :before-close="handleClose">
        <div class="checkDetails">
          <el-tabs type="border-card">
            <el-tab-pane label="申请信息">
              <div class="main">
                <div class="title">申请详情</div>
                <div class="content">
                  <div class="list">
                    <span>发票申请编号：{{invoiceObj.applyNo}}</span>
                    <span>发票类型：{{invoiceObj.type}}</span>
                    <span>申请时间：{{invoiceObj.invoiceTime}}</span>
                  </div>
                  <div class="list">
                    <span>价税合计总额（元）：{{invoiceObj.invoiceAmount}}</span>
                    <span>开票内容：{{invoiceObj.invoiceContent}}</span>
                    <span style="margin-right: 0px;">个税：{{invoiceObj.personalIncomeTax}}</span>
                  </div>
                  <div class="list">
                    <span>增值税：{{invoiceObj.valueAddedTax}}</span>
                    <span>附加税：{{invoiceObj.additionalTax}}</span>
                    <span>服务费：{{invoiceObj.serviceCharge}}</span>
                  </div>
                  <div class="list">
                    <span style="min-width:32.6%">
                      <div class="text">合同文件：</div>
                      <div class="icon">
                        <img :src="invoiceObj.settleImg" alt />
                      </div>
                    </span>
                    <span style="min-width:32.6%">
                      <div class="text">结算单：</div>
                      <div class="icon">
                        <img :src="invoiceObj.settleImg" alt />
                      </div>
                    </span>
                    <span>
                      <div
                        class="text"
                        v-if="invoiceObj.deliverer"
                      >业务进度：{{invoiceObj.deliverer.statusName}}</div>
                      <div style="height:50px;float:left"></div>
                    </span>
                  </div>
                  <div class="list">
                    <span>申请方联系电话：{{invoiceObj.applyMobile}}</span>
                  </div>
                </div>
              </div>
              <div class="main">
                <div class="title">发票购买方</div>
                <div class="content">
                  <div class="list">
                    <span>名称：{{invoiceObj.merchantName}}</span>
                    <span>纳税人识别号：{{invoiceObj.merchantCreditCode}}</span>
                    <span style="margin-right: 0px;">地址：{{invoiceObj.merchantAddr}}</span>
                  </div>
                  <div class="list">
                    <span>电话：{{invoiceObj.merchantMobile}}</span>
                    <span>开户行：{{invoiceObj.merchantBank}}</span>
                    <span>对公账户：{{invoiceObj.merchantAccount}}</span>
                  </div>
                </div>
              </div>
              <div class="main">
                <div class="title">发票销售方</div>
                <div class="content">
                  <div class="list">
                    <span>名称：{{invoiceObj.businessName}}</span>
                    <span>纳税人识别号：{{invoiceObj.businessmenCreditCode}}</span>
                    <span>银行开户：{{invoiceObj.businessBank}}</span>
                    <span style="margin-right: 0px;">税务报道机构：{{invoiceObj.taxAuthorities}}</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="业务办理">
              <div class="main">
                <div class="title">审核详情</div>
                <div class="content" v-if="invoiceObj.deliverer">
                  <div class="list" v-if="invoiceObj.invoice">
                    <span>审核状态：{{invoiceObj.invoice.statusName}}</span>
                  </div>
                  <div class="list">
                    <span>审核内容：{{invoiceObj.deliverer.auditContent}}</span>
                  </div>
                  <div class="list">
                    <span>交付内容：{{invoiceObj.deliverer.delivererContent}}</span>
                  </div>
                  <div class="list">
                    <span>收件人：{{invoiceObj.deliverer.mailTo}}</span>
                  </div>
                  <div class="list">
                    <span>联系电话：{{invoiceObj.deliverer.mailMobile}}</span>
                  </div>
                  <div class="list">
                    <span>邮寄地址：{{invoiceObj.deliverer.mailAddr}}</span>
                  </div>
                </div>
              </div>
              <div class="main">
                <div class="title">交付信息</div>
                <div class="content" v-if="invoiceObj.deliverer">
                  <div class="list">
                    <span>快递单号：{{invoiceObj.deliverer.delivererMailNo}}</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="已开发票">
              <div class="main">
                <div class="title">发票详情</div>
                <div class="content" v-if="invoiceObj.invoice">
                  <div class="list">
                    <span>发票编号：{{invoiceObj.invoice.applyNo}}</span>
                    <span>开票时间：{{invoiceObj.invoice.invoiceTime}}</span>
                    <span style="margin-right: 0px;">快递单号：{{invoiceObj.invoice.mailNo}}</span>
                  </div>
                  <!-- <div class="list"><span class="span">支付凭证：</span><div><img :src="invoiceObj.invoice" alt=""></div></div> -->
                </div>
              </div>
              <div class="main">
                <div class="title">发票照片</div>
                <div class="photo" v-if="invoiceObj.invoice">
                  <img :src="invoiceObj.invoice.invoiceImg" alt />
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="完税证明">
              <div class="main">
                <div class="title">完税证明详情</div>
                <div class="content" v-if="invoiceObj.invoice">
                  <div class="list">
                    <span>完税批号：{{invoiceObj.invoice.taxNo}}</span>
                    <span style="margin-right: 0px;">完税时间：{{invoiceObj.invoice.taxTime}}</span>
                  </div>
                </div>
              </div>
              <div class="main">
                <div class="title">完税证明图片</div>
                <div class="photo" v-if="invoiceObj.invoice">
                  <img :src="invoiceObj.invoice.taxVoucher" alt />
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-dialog>
      <!-- 新建进度  已开具-->
      <el-dialog
        title="新建进度"
        :visible.sync="dialogInvoice1"
        width="755px"
        :before-close="handleClose"
      >
        <div style="width: 435px; margin: 0 auto; text-align: left;">
          <el-form ref="openForm" :model="openForm" :rules="openRules" label-width="100px">
            <el-form-item label="发票进度：">
              <div style="width:233px">
                <el-input placeholder="已开具" :disabled="true"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="发票编码：" prop="invoiceNo">
              <div style="width:233px">
                <el-input v-model="openForm.invoiceNo"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="开票时间：" prop="invoiceTime">
              <div style="width:233px">
                <el-date-picker
                  v-model="openForm.invoiceTime"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="发票照片：">
              <el-upload
                class="avatar-uploader"
                :action="data.action"
                :data="data.d"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="openForm.invoiceImg" :src="openForm.invoiceImg" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="openConfirm('openForm')">确定</el-button>
              <el-button @click="dialogInvoice1 = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!-- 新建进度 已邮寄 -->
      <el-dialog
        title="新建进度"
        :visible.sync="dialogInvoice2"
        width="598px"
        :before-close="handleClose"
      >
        <div style="width: 375px; margin: 0 auto; text-align: left;">
          <el-form ref="mailForm" :model="mailForm" label-width="100px">
            <el-form-item label="发票进度：">
              <div style="width:233px">
                <el-input placeholder="已邮寄" :disabled="true"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="快递单号：">
              <div style="width:233px">
                <el-input v-model="mailForm.mailNo" placeholder="单行输入"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="mailConfirm('mailForm')">确定</el-button>
              <el-button @click="dialogInvoice2 = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
import pagination from "@/components/pagination";
export default {
  data() {
    return {
      invoiceObj: {},
      dialogInvoice: false,
      dialogInvoice1: false,
      dialogInvoice2: false,
      tableData: [],
      typeOptions: [
        {
          value: "20",
          label: "增值税专用发票"
        },
        {
          value: "10",
          label: "普通发票"
        },
        {
          value: "30",
          label: "电子发票"
        }
      ],
      statusOptions: [
        {
          value: "1000",
          label: "待审核"
        },
        {
          value: "1010",
          label: "申请审核失败"
        },
        {
          value: "1020",
          label: "待分配"
        },
        {
          value: "1030",
          label: "待处理"
        },
        {
          value: "1050",
          label: "已开具"
        },
        {
          value: "1070",
          label: "审核通过"
        },
        {
          value: "1090",
          label: "已完成"
        },
        {
          value: "1300",
          label: "交付审核失败"
        }
      ],
      total: 0,
      currentPage: "",
      pageSzie: 10,
      openForm: {
        id: "",
        nextStatus: "1050",
        invoiceNo: "",
        invoiceTime: "",
        invoiceImg: ""
      },
      openRules: {
        invoiceNo: [
          { required: true, message: "请输入活动名称", trigger: "blur" }
        ],
        invoiceTime: [
          { required: true, message: "请输入活动名称", trigger: "blur" }
        ]
      },
      mailForm: {
        id: "",
        nextStatus: "1080",
        mailNo: ""
      },
      invoiceTime: "",
      status: "",
      applyNo: "",
      type: "",
      data: {
        d: {},
        action: ""
      }
    };
  },
  mounted() {
    this.getUploadConfig();
    this.delivererInvoicesPost();
  },
  methods: {
    getUploadConfig() {
      var that = this;
      post(api.getOssConfig).then(
        d => {
          console.log(d, "阿里接口");
          that.data.d["key"] = "zc_wxapplet_" + new Date().getTime() + ".jpg";
          that.data.d["Bucket"] = d.Bucket;
          that.data.d["OSSAccessKeyId"] = d.OSSAccessKeyId;
          that.data.d["signature"] = d.Signature;
          that.data.d["policy"] = d.policy;
          that.data.d["success_action_status"] = d.success_action_status;
          that.data.action = d.url;
        },
        err => {
          //error callback
        }
      );
    },
    // 开具确认
    openConfirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          post(api.delivererAssignment, this.openForm).then(
            d => {
              console.log(d, "ddddddddddddddddd");
              if (d.status === 0) {
                this.dialogInvoice1 = false;
                this.delivererInvoicesPost();
              }
            },
            err => {
              //error callback
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 邮寄确认
    mailConfirm() {
      if (this.mailForm.mailNo == "") {
        return this.$message.error("请填写订单号");
      }
      post(api.delivererAssignment, this.mailForm).then(
        d => {
          console.log(d, "ddddddddddddddddd");
          if (d.status === 0) {
            this.dialogInvoice2 = false;
            this.delivererInvoicesPost();
          }
        },
        err => {
          //error callback
        }
      );
    },
    auditSubmit(row) {
      post(api.delivererAssignment, {
        id: row.id,
        nextStatus: 1060
      }).then(
        d => {
          console.log(d, "ddddddddddddddddd");
          if (d.status === 0) {
            this.delivererInvoicesPost();
          }
        },
        err => {
          //error callback
        }
      );
    },
    reset() {
      this.invoiceTime = "";
      this.applyNo = "";
      this.type = "";
      this.status = "";
      this.delivererInvoicesPost();
    },
    delivererInvoicesPost(size) {
        const loading = this.$loading({
        lock: true,
        spinner: "loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      post(api.delivererApplyInvoices, {
        pageIndex: size || 1,
        pageSize: this.pageSzie,
        delivererId: "",
        invoiceTime: this.invoiceTime,
        applyNo: this.applyNo,
        type: this.type,
        status: this.status
      }).then(
        d => {
          console.log(d, "ddddddddddddddddd");
             loading.close();
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.total = d.data.count;
            this.tableData = d.data.rows;
          }
        },
        err => {
          //error callback
        }
      );
    },
    handleClick(row) {
      console.log(row);
      post(api.queryInvoiceDeliverer, {
        id: row.id
      }).then(
        d => {
          console.log(d);
          if (d.status === 0) {
            console.log(d, "????????????");
            this.dialogInvoice = true;
            this.invoiceObj = d.data;
          }
        },
        err => {
          //error callback
        }
      );
    },
    newProgress(row) {
      if (row.status == "1030") {
        this.openForm.id = row.id;
        this.dialogInvoice1 = true;
      } else if (row.status == "1070") {
        this.mailForm.id = row.id;
        this.dialogInvoice2 = true;
      }
    },
    handleClose(done) {
      done();
    },
    handleSizeChange(val) {
      this.pageSzie = val;
      console.log(`每页 ${val} 条aaaaa`);
      this.delivererInvoicesPost();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}aaaaaaaaaaaaaaaa`);
      this.delivererInvoicesPost(val);
    },
    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      var result = res.substring(
        res.indexOf("https://gsb-zc.oss-cn-beijing.aliyuncs.com"),
        res.indexOf("</Location>")
      );
      this.openForm.invoiceImg = result;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    }
  },
  components: {
    pagination: pagination
  }
};
</script>

<style lang="less" scoped>
.invoiceManagement {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      overflow: hidden;
      .item {
        height: 46px;
        line-height: 46px;
        float: left;
        margin-bottom: 10px;
        span {
          display: inline-block;
          width: 110px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: right;
          margin-right: 10px;
        }
        div {
          display: inline-block;
          width: 233px;
          height: 46px;
        }
      }
    }
    .middle-button {
      width: 100%;
      text-align: left;
      padding-top: 10px;
    }
    .bottom-table {
      width: 100%;
      margin-top: 20px;
    }
    .bottom-pag {
      width: 100%;
      margin-top: 20px;
    }
    .dialog-header {
      width: 100%;
      height: 49px;
      line-height: 49px;
      background: rgba(20, 147, 250, 0.1);
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: #333333;
      text-align: left;
      div {
        float: left;
        width: 116px;
        height: 49px;
        background: rgba(20, 147, 250, 1);
        color: #ffffff;
        text-align: center;
        margin-right: 28px;
      }
    }
    .dialong-content {
      width: 100%;
      height: 565px;
      background: rgba(216, 216, 216, 0.28);
      margin-top: 23px;
    }
  }
  .details {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .content {
      width: 100%;
      .name {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .box {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        background: rgba(250, 250, 250, 1);
        border-radius: 6px;
        text-align: left;
        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 0px 55px;
          line-height: 36px;
        }
      }
      .box1 {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        border-radius: 6px;
        text-align: left;
        overflow: hidden;
        .item {
          float: left;
          height: 93px;
          margin-right: 100px;
          margin-bottom: 20px;
          div {
            float: left;
            min-width: 55px;
            height: 93px;
          }
          .picture {
            width: 167px;
            height: 93px;
            background: rgba(246, 246, 246, 1);
            border-radius: 8px;
            border: 1px solid rgba(198, 198, 198, 1);
          }
        }
      }
    }
  }
  .checkDetails {
    width: 100%;
    .main {
      width: 100%;
      height: auto;
      background: rgba(244, 244, 244, 0.78);
      border-radius: 6px;
      padding: 10px 20px;
      box-sizing: border-box;
      margin-bottom: 20px;
      .title {
        width: 100%;
        text-align: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 34px;
      }
      .content {
        width: 100%;
        padding: 10px 18px;
        box-sizing: border-box;
        text-align: left;
        padding-bottom: 0px;
        .list {
          width: 100%;
          overflow: hidden;
          margin-bottom: 10px;
          span {
            // margin-right: 70px;
            display: inline-block;
            min-width: 33%;
            font-size: 14px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            .text {
              margin-right: 10px;
              float: left;
            }
            .icon {
              float: left;
              width: 139px;
              height: 50px;
              background: rgba(227, 227, 227, 1);
              img {
                display: block;
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
      .photo {
        width: 881px;
        height: 267px;
        margin: 20px auto;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        border: 1px solid rgba(220, 220, 220, 1);
        padding: 10px;
        img {
          display: block;
          height: 100%;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/trading/invoice/invoiceTransact.vue